// extracted by mini-css-extract-plugin
module.exports = {"root":"ForgotPasswordForm_root__3Lmlc","form":"ForgotPasswordForm_form__3bKxA","button":"ForgotPasswordForm_button__2h_AB"};